import { useEffect, useState } from 'react'
import * as sx from '../../common/stylesInline/report_daily_branch'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { Item, SingleInputModal } from '../../common/snippets'
import useToken from '../../helpers/useTokens'
import moment from 'moment'
import { Box, Stack, Button } from '@mui/material'
import { GetRequest, PostRequest } from '../../common/api'
import { urls } from '../../common/constants'
import { RenderTable } from '../Reports/analysisReport/summmaryTable'
import { getExApprovalHeaders } from './constant'
import { alertAtom } from '../../common/jotaiState/globalStateAtoms'
import { useAtom } from 'jotai'
import { focusElemnt, navigation3 } from '../../common/helper'
import { useTranslation } from '../../../i18n/I18nProvider'

export const ExpenseApproval = () => {
  const { translations } = useTranslation()
  const op = translations?.operationsPrivilege || {}
  const cs = translations?.common || {}
  const exApprovalHeaders = getExApprovalHeaders(translations)
  const { loginData } = useToken()
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
  const [cityList, setCityList] = useState([])
  const [branchList, setBranchList] = useState([])
  const [userList, setUserList] = useState([])
  const [city, setCity] = useState()
  const [branch, setBranch] = useState()
  const [user, setUser] = useState()
  const [tableData, setTableData] = useState([])
  const [, setAlert] = useAtom(alertAtom)
  const [modal, setModal] = useState(false)
  const [rejectAccountID, setRejectAccountID] = useState()
  const [RejectionRemarks, setRejectionRemarks] = useState()
  useEffect(() => {
    focusElemnt('goBtn')
  }, [])
  const handleGo = async () => {
    const obj = {
      CompanyID: loginData.intCompanyID,
      BranchID: 0,
      CityID: 0,
      UserID: 0,
      FromDate: fromDate,
      ToDate: toDate,
      Mode: 2,
    }
    const res = await GetRequest(urls.getExpenseEntryDetails + '?', obj)
    if (res.status === 'Success') {
      const temp = res?.Data?.Table || []
      const { cityList, branchList, userList } = temp.reduce(
        (acc, item) => {
          if (!acc.cityListSet.has(item.CityID)) {
            acc.cityListSet.add(item.CityID)
            acc.cityList.push({ id: item.CityID, name: item.CityName })
          }
          if (!acc.branchListSet.has(item.BranchID)) {
            acc.branchListSet.add(item.BranchID)
            acc.branchList.push({ id: item.BranchID, name: item.BranchName, CityID: item.CityID })
          }
          if (!acc.userListSet.has(item.UserID)) {
            acc.userListSet.add(item.UserID)
            acc.userList.push({ id: item.UserID, name: item.UserName, CityID: item.CityID, BranchID: item.BranchID })
          }
          return acc
        },
        { cityList: [], cityListSet: new Set(), branchList: [], branchListSet: new Set(), userList: [], userListSet: new Set() }
      )
      if (cityList.length) {
        const ownCity = cityList.find((item) => item.id === loginData.intBranchCityID)
        setCity(ownCity || {})
        setCityList(cityList)
      }
      if (branchList.length) {
        const ownBranch = branchList.find((item) => item.id === loginData.intBranchID)
        setBranch(ownBranch || {})
        setBranchList(branchList)
      }
      if (userList.length) {
        const ownUser = userList.find((item) => item.id === loginData.intUserID)
        setUser(ownUser || {})
        setUserList(userList)
      }
    }
  }
  const handleLoad = () => {
    fetchData()
  }
  const fetchData = async () => {
    const obj = {
      CompanyID: loginData.intCompanyID,
      BranchID: branch?.id || 0,
      CityID: city?.id || loginData.intBranchCityID,
      UserID: user?.id || 0,
      FromDate: fromDate,
      ToDate: toDate,
      Mode: 2,
    }
    const res = await GetRequest(urls.getExpenseEntryDetails + '?', obj)
    if (res.status === 'Success') {
      const temp = res.Data.Table1.map((item, index) => {
        return {
          ...item,
          SN: index + 1,
          approval: (
            <Item sx={{ display: 'flex', gap: '10px', padding: '0px' }}>
              <Button
                style={{ fontSize: '1.3rem', width: '50%', height: '30px', border: '1px solid ' }}
                onClick={() => handleAccept(item.ID)}
              >
                {op.accept || 'Accept'}
              </Button>{' '}
              <Button
                style={{ fontSize: '1.3rem', width: '50%', height: '30px', border: '1px solid' }}
                onClick={() => rejectPopup(item.ID)}
              >
                {op.reject || 'Reject'}
              </Button>
            </Item>
          ),
        }
      })
      setTableData(temp)
    }
  }
  const handleAccept = (AccountID) => {
    const obj = {
      AccountID,
      Mode: 1,
      RejectionRemarks: '',
    }
    PostRequest(urls.expenseEntryApprovalUpdate, obj).then((res) => {
      if (res.status === 'Success') {
        fetchData()
        setAlert({ show: true, success: true, msg: op.expenseEntryAcceptedSuccessfully || 'Expense Entry Accepted successfully', nextId: '' })
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    })
  }
  const rejectPopup = (AccountID) => {
    setRejectAccountID(AccountID)
    setModal('reject')
  }
  const closePopup = () => {
    setModal(false)
    setAlert({ show: false })
    setRejectAccountID()
    setRejectionRemarks()
  }
  const handleReject = () => {
    const obj = {
      AccountID: rejectAccountID,
      Mode: 0,
      RejectionRemarks: RejectionRemarks,
    }
    PostRequest(urls.expenseEntryApprovalUpdate, obj).then((res) => {
      if (res.status === 'Success') {
        fetchData()
        setAlert({ show: true, success: true, msg: op.expenseEntryRejectedSuccessfully || 'Expense Entry Rejected successfully', nextId: '',close: closePopup })
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    })
  }
  const inputModalFucntion = {
    updateModal: setModal,
    onChangeInput: setRejectionRemarks,
    onClickButton: handleReject,
    onCloseCallback: () => setModal(false),
  }
  const inputModalData = {
    headTxt: op.rejectionRemarks || 'Rejection Remarks',
    inputId: 'rejectRemarks',
    inputLabel: op.enterRejectionRemarks || 'Enter Rejection Remarks',
    inputName: 'rejectRemarks',
    inputType: 'text',
    inputValue: RejectionRemarks,
    mainButtonLabel: op.reject || 'Reject',
    mainButtonId: 'rejectButton',
  }
  return (
    <Box>
      <Stack direction="row" flexWrap="wrap" sx={{ padding: '10px 0', gap: '10px' }}>
        <Item sx={{ width: '18%', ...sx.itemsx }} className="input--container bookingDatePicker">
          <Datepicker
            label={op.selectFromDate || 'Select From Date'}
            id={'fromDateId'}
            dateChange={(date) => {
              setFromDate(date.format('YYYY-MM-DD'))
              focusElemnt('toDateId')
            }}
            width="100%"
          />
        </Item>
        <Item sx={{ width: '18%', ...sx.itemsx }} className="input--container bookingDatePicker">
          <Datepicker
            label={op.selectToDate || 'Select to Date'}
            id={'toDateId'}
            dateChange={(date) => {
              setToDate(date.format('YYYY-MM-DD'))
              focusElemnt('goBtn')
            }}
            width="100%"
          />
        </Item>
        <Button
          id="goBtn"
          className="select-lr-btn"
          variant="contained"
          color="error"
          style={{ backgroundColor: '#fe5200', fontSize: '1.3rem' }}
          onClick={() => handleGo()}
          onKeyDown={(e) => navigation3(e, 'cityId', 'toDateId', handleGo)}
        >
          {cs.go || 'Go'}
        </Button>
        <Item sx={{ ...sx.itemsxGrow }}>
          <DropDownOA
            id="cityId"
            nextId="branchId"
            prevId="goBtn"
            type ={'set_default'}
            label={op.selectCity || 'Select City'}
            width="100%"
            data={cityList}
            dataKey="name"
            idKey="id"
            onSelect={setCity}
            defaultvalue={city?.name || ''}
            value={city?.name || ''}
          />
        </Item>
        <Item sx={{ ...sx.itemsxGrow }}>
          <DropDownOA
            id="branchId"
            nextId="userId"
            prevId="cityId"
            type ={'set_default'}
            label={op.selectBranch || 'Select Branch'}
            width="100%"
            data={branchList}
            dataKey="name"
            idKey="id"
            onSelect={setBranch}
            defaultvalue={branch?.name || ''}
            value={branch?.name || ''}
          />
        </Item>
        <Item sx={{ ...sx.itemsxGrow }}>
          <DropDownOA
            id="userId"
            nextId="loadBtn"
            prevId="branchId"
            type ={'set_default'}
            label={op.selectUser || 'Select User'}
            width="100%"
            data={userList}
            dataKey="name"
            idKey="id"
            onSelect={setUser}
            defaultvalue={user?.name || ''}
            value={user?.name || ''}
          />
        </Item>
        <Item sx={{ ...sx.itemsx }}>
          <Button
            id="loadBtn"
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            onClick={() => handleLoad()}
            onKeyDown={(e) => navigation3(e, 'fromDateId', 'userId')}
          >
            {cs.load || 'Load'}
          </Button>
        </Item>
      </Stack>
      {tableData.length ? <RenderTable data={tableData} header={exApprovalHeaders} key1="ef4wd" key2="wdsw30" key3="0d3a3" /> : <></>}
      {modal === 'reject' ? <SingleInputModal functions={inputModalFucntion} data={inputModalData} /> : ''}
    </Box>
  )
}
